import Modal from "@/components/Modal";
import Form from "@/components/Form";

import "./style.css";

export default class LoginModal extends Modal {
  static selector = ".login-modal";

  constructor(block) {
    super(block);

    this.block = block;

    this.loginFormElement = this.block.querySelector(
      ".login-modal__login-form"
    );
    this.resetPasswordFormElement = this.block.querySelector(
      ".login-modal__reset-password-form"
    );

    this.modalTitle = this.block.querySelector(".modal__title");

    this.passwordResetButton = this.block.querySelector(
      ".form__forgot-password"
    );
    this.backToSigninButton = this.block.querySelector(".form__signin--back");

    this.successScreen = this.block.querySelector(
      ".reset-password-email__success"
    );

    this.sendAgainButton = this.block.querySelector(
      ".reset-password-email__cta"
    );
  }

  initForm = (formElement) => {
    this.form = new Form(formElement, {
      onSubmitSucceeded: this.handleSubmitSucceeded,
      onSubmitFailed: this.handleSubmitFailed,
      resetAfterSubmit: false,
    });
  };

  handleSubmitFailed = () => {};

  handleSubmitSucceeded = (res) => {
    if (res.redirectUrl) {
      // is login action
      window.location.href = res.redirectUrl;
    } else {
      this.showSuccessMessage();
    }
  };

  handleSendAgainClick = () => {
    this.successScreen.classList.add("reset-password-email__success--hidden");
    this.resetPasswordFormElement.classList.remove("form--hidden");
    this.modalTitle.innerText = window.saee.copy["Password Recovery"];

    this.initForm(this.resetPasswordFormElement);
  };

  showSuccessMessage = () => {
    this.modalTitle.innerText = window.saee.copy["We have sent you an email"];
    this.resetPasswordFormElement.classList.add("form--hidden");
    this.successScreen.classList.remove(
      "reset-password-email__success--hidden"
    );
  };

  resetModalContent = () => {
    if (this.loginFormElement) {
      this.loginFormElement.classList.remove("form--hidden");
      this.resetPasswordFormElement.classList.add("form--hidden");
      this.modalTitle.innerText = window.saee.copy["Log in"];
      this.successScreen.classList.add("reset-password-email__success--hidden");
    } else if (this.resetPasswordFormElement) {
      this.successScreen.classList.add("reset-password-email__success--hidden");
      this.resetPasswordFormElement.classList.remove("form--hidden");
      this.modalTitle.innerText = window.saee.copy["Password Recovery"];
    }
  };

  clearFormErrorState = () => {
    this.block.querySelectorAll(".form__error").forEach((error) => {
      error.innerText = "";
    });
    this.block
      .querySelectorAll(".form__group-error")
      .forEach((error) => (error.innerText = ""));
    this.block.querySelectorAll(".form__group").forEach((group) => {
      if (group.classList.contains("form__group--wrong")) {
        group.classList.remove("form__group--wrong");
      }
    });
  };

  handleFormSwitch = () => {
    if (this.loginFormElement.classList.contains("form--hidden")) {
      this.loginFormElement.classList.remove("form--hidden");
      this.resetPasswordFormElement.classList.add("form--hidden");
      this.modalTitle.innerText = window.saee.copy["Log in"];
      this.initForm(this.loginFormElement);
    } else {
      this.loginFormElement.classList.add("form--hidden");
      this.resetPasswordFormElement.classList.remove("form--hidden");
      this.modalTitle.innerText = window.saee.copy["Password Recovery"];

      this.initForm(this.resetPasswordFormElement);
    }

    this.clearFormErrorState();
  };

  // Lifecycle methods
  onReady() {
    if (this.passwordResetButton) {
      this.passwordResetButton.addEventListener("click", this.handleFormSwitch);
    }

    if (this.backToSigninButton) {
      this.backToSigninButton.addEventListener("click", this.handleFormSwitch);
    }

    if (this.sendAgainButton) {
      this.sendAgainButton.addEventListener("click", this.handleSendAgainClick);
    }
  }

  modalDidMount = async () => {};
  modalWillOpen = async () => {
    if (!this.form) {
      if (this.loginFormElement) {
        this.initForm(this.loginFormElement);
      } else if (this.resetPasswordFormElement) {
        this.initForm(this.resetPasswordFormElement);
      }
    }
  };

  modalDidUpdate = async () => {};
  modalDidClose = async () => {
    this.form = null;

    this.clearFormErrorState();
    this.resetModalContent();
  };

  onDestroy() {
    if (this.passwordResetButton) {
      this.passwordResetButton.removeEventListener(
        "click",
        this.handleFormSwitch
      );
    }

    if (this.backToSigninButton) {
      this.backToSigninButton.removeEventListener(
        "click",
        this.handleFormSwitch
      );
    }

    if (this.sendAgainButton) {
      this.sendAgainButton.removeEventListener(
        "click",
        this.handleSendAgainClick
      );
    }
  }
}
